import { FC } from "react";
import { XIcon } from "lucide-react-native";
import { useFormContext } from "react-hook-form";

import { VnBox } from "@/components/VnBox";
import { VnButtonSelectInput } from "@/components/VnButtonSelectInput/VnButtonSelectInput";
import { VnFormField, VnFormLabel } from "@/components/VnForm";
import { VnIcon } from "@/components/VnIcon";
import { VnTextInput } from "@/components/VnTextInput/VnTextInput";
import { VnTouchableOpacity } from "@/components/VnTouchableOpacity";
import {
  householdMemberRelations,
  HouseholdMemberRelationshipFieldsType,
  HouseholdMemberRelationsType,
} from "@/domain/householdMember";

type HouseholdMemberRelationshipFormPropsType = {
  relationshipOptions?: HouseholdMemberRelationsType[];
};

export const HouseholdMemberRelationshipForm: FC<
  HouseholdMemberRelationshipFormPropsType
> = params => {
  const { control, watch, setValue } = useFormContext<{
    householdMemberRelationship: {
      relationship?: HouseholdMemberRelationshipFieldsType["relationship"];
      otherRelationship: HouseholdMemberRelationshipFieldsType["otherRelationship"];
    };
  }>();

  const relationshipValue = watch("householdMemberRelationship.relationship");

  const relationshipOptions = params?.relationshipOptions?.length
    ? householdMemberRelations.filter(option =>
        params.relationshipOptions?.some(
          availableOption => availableOption === option.value,
        ),
      )
    : householdMemberRelations;

  return (
    <VnBox className="gap-2">
      <VnFormLabel
        i18nKey="native:addHouseholdMemberScreen.relationshipToMe"
        isRequired
      />
      {relationshipValue === "OTHER" ? (
        <VnFormField
          control={control}
          name="householdMemberRelationship.otherRelationship"
          render={() => (
            <VnBox className="flex flex-row items-center">
              <VnBox className="flex-1">
                <VnTextInput
                  control={control}
                  name="householdMemberRelationship.otherRelationship"
                  isRequired={false}
                />
              </VnBox>
              <VnTouchableOpacity
                className="px-3.5"
                onPress={() => {
                  setValue(
                    "householdMemberRelationship.relationship",
                    undefined,
                  );
                  setValue("householdMemberRelationship.otherRelationship", "");
                }}>
                <VnIcon as={XIcon} />
              </VnTouchableOpacity>
            </VnBox>
          )}
        />
      ) : (
        <>
          <VnButtonSelectInput
            control={control}
            name="householdMemberRelationship.relationship"
            options={relationshipOptions}
            columns={2}
          />
        </>
      )}
    </VnBox>
  );
};
